<template>
    <section class="rtb-form-section" data-field="screen_package_id">
        <fieldset class="rtb-form-fieldset">
            <legend>Пакет экранов</legend>
            <div v-if="canChange" class="field">
                <label class="field__label" for="rtb-form-package">Пакет</label>
                <select
                    id="rtb-form-package"
                    :value="modelValue"
                    class="select-input"
                    :disabled="disabled"
                    :class="{ 'is-invalid': errors.screen_package_id }"
                    @change="emit('update:modelValue', Number($event.target.value) || null)"
                >
                    <option :value="null">Выберите пакет</option>
                    <option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">
                        {{ pkg.name }} ({{ pkg.frames_count }} экр., {{ formatMoney(pkg.price_per_day) }}/сут.)
                    </option>
                </select>
                <p v-if="errors.screen_package_id" class="field__error">{{ errors.screen_package_id }}</p>
            </div>
            <p v-else class="field__hint">
                <strong>{{ selectedPackage?.name }}</strong> — пакет нельзя изменить после создания
            </p>
            <p v-if="selectedPackage" class="field__hint">
                Мин. период: {{ selectedPackage.min_period_value }}
                {{ selectedPackage.min_period_type === 'week' ? 'нед.' : 'дн.' }}
                · Экранов: {{ selectedPackage.frames_count ?? selectedPackage.frames?.length ?? 0 }}
            </p>
        </fieldset>

        <fieldset class="rtb-form-fieldset">
            <legend>Стоимость (авторасчёт)</legend>
            <p v-if="priceLoading" class="field__hint">Расчёт…</p>
            <div v-else-if="pricePreview" class="price-preview">
                <div class="price-item">
                    <span class="price-label">Суток</span>
                    <span class="price-value">{{ pricePreview.days }}</span>
                </div>
                <div v-for="col in (pricePreview.columns || [])" :key="col.key" class="price-column-block">
                    <div class="price-column-title">{{ col.label }}</div>
                    <div class="price-item">
                        <span class="price-label">За сутки</span>
                        <span class="price-value">{{ formatMoney(col.price_per_day) }}</span>
                    </div>
                    <div class="price-item price-item--total">
                        <span class="price-label">Итого</span>
                        <span class="price-value">{{ formatMoney(col.total) }}</span>
                    </div>
                </div>
            </div>
            <p v-if="priceError" class="field__error">{{ priceError }}</p>
        </fieldset>
    </section>
</template>

<script setup>
defineProps({
    modelValue: { type: [Number, String], default: null },
    packages: { type: Array, default: () => [] },
    selectedPackage: { type: Object, default: null },
    canChange: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    errors: { type: Object, default: () => ({}) },
    priceLoading: { type: Boolean, default: false },
    pricePreview: { type: Object, default: null },
    priceError: { type: String, default: '' },
    formatMoney: { type: Function, required: true },
});

const emit = defineEmits(['update:modelValue']);
</script>
